import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoggingService } from '../../core/utils/logging.service';

const API_REGISTER_URL = `${environment.api.baseUrl}/authentication/register`;

export interface IPostRegisterData {
  email: string;
  // password: string;
  firstName: string;
  lastName: string;
}

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  private readonly http = inject(HttpClient);
  private readonly loggingService = inject(LoggingService);

  register(data: IPostRegisterData) {
    return this.http.post(API_REGISTER_URL, data).pipe(
      tap((res) => this.loggingService.log('register', res)),
      catchError((err) => {
        // ! TODO implement error handling
        this.loggingService.error('register', err);
        return throwError(() => err);
      })
    );
  }
}
